import { ApolloClient, InMemoryCache, ApolloLink, HttpLink } from '@apollo/client';
import { GATEWAY_URL } from './server.config';

/**
 * Reads utoken from every response header and saves it to sessionStorage.
 * This runs AFTER the HTTP response is received.
 */
const afterwareLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((response) => {
    const context = operation.getContext();
    const responseHeaders = context.response?.headers;
    if (responseHeaders) {
      const utoken = responseHeaders.get('utoken');
      if (utoken) {
        sessionStorage.setItem('utoken', utoken);
      }
    }
    return response;
  });
});

/**
 * Attaches utoken from sessionStorage to every outgoing request header.
 */
const authLink = new ApolloLink((operation, forward) => {
  const utoken = sessionStorage.getItem('utoken');
  operation.setContext(({ headers = {} }: { headers?: Record<string, string> }) => ({
    headers: {
      ...headers,
      ...(utoken ? { utoken } : {}),
    },
  }));
  return forward(operation);
});

const httpLink = new HttpLink({ uri: GATEWAY_URL });

export const apolloClient = new ApolloClient({
  // afterwareLink → authLink → httpLink
  // Request flows left to right; response flows right to left
  link: ApolloLink.from([afterwareLink, authLink, httpLink]),
  cache: new InMemoryCache(),
});
